(function () {
  function initSlider(section) {
    var slider = section.querySelector('slider-component.slider--phone');
    if (!slider) return;

    var buttonContainer = section.querySelector('.slider__buttons.slider--phone');
    if (!buttonContainer) return;

    var buttons = Array.from(buttonContainer.querySelectorAll('.slider__button'));
    if (!buttons.length) return;

    function getPageWidth() {
      return slider.offsetWidth;
    }

    function updateButtons() {
      var pageWidth = getPageWidth();
      if (!pageWidth) return;
      var currentPage = Math.round(slider.scrollLeft / pageWidth);
      buttons.forEach(function (btn, index) {
        btn.classList.toggle('slider__button--current', index === currentPage);
      });
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        slider.scrollTo({ left: index * getPageWidth(), behavior: 'smooth' });
      });
    });

    slider.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-section-name="featured-collection"]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section re-render (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-name="featured-collection"]');
    if (section) initSlider(section);
  });
})();
